import { H5, Img, Modal, P, PropsModal, noImage } from '@vgrubs/components';
import { useState } from 'react';

export const CourierModal = ({
  modalIsOpen,
  closeModal,
  courier,
}: PropsModal & {
  modalIsOpen: boolean;
  courier:
    | {
        name?: string | null;
        status?: 'pending' | 'assigned' | null;
        phoneNumber?: string | null;
        photoUrl?: string | null;
      }
    | null
    | undefined;
}) => {
  const [image] = useState<string>(noImage);

  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      textAlign={'left'}
      zIndex={110}
    >
      {courier?.photoUrl && (
        <Img
          $width="100%"
          src={courier?.photoUrl}
          alt="courier"
          onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
            e.currentTarget.src = image;
          }}
        />
      )}
      {courier?.name && (
        <H5 $mb="8" $mt="16">
          {courier?.name}
        </H5>
      )}
      {courier?.phoneNumber && <P $mb="8">{courier?.phoneNumber}</P>}
    </Modal>
  );
};
